import axios from 'axios';

export default class Registrations {
  public processRegistration(account: any): Promise<any> {
    return axios.post('api/register', account);
  }

  public processMarketerRegistration(account: any, link: string): Promise<any> {
    return axios.post('api/register' + (link && '?mod=' + link), account);
  }

  public processLogin(account: any): Promise<any> {
    return axios.post('api/authenticate', account);
  }

  public processResendActivation(account: any): Promise<any> {
    return axios.post('api/resend', account);
  }
}
